<template>
  <div>
    <h1>{{ $t("delegation.delegationNew.title") }}</h1>
    <div class="mt-3 elevation-12 grey lighten-4">
      <v-row align-content="center" align="center" class="text-center justyfy-center">
        <v-spacer></v-spacer>
        <v-col cols="12" lg="4" class="choose-box elevation-5"
          ><h3>
            {{ $t("delegation.delegationNew.independent") }}
          </h3>
          <v-icon size="150px" class="font-weight-regular">fa-calendar-plus</v-icon>
          <p>
            {{ $t("delegation.delegationNew.independentDescription") }}
          </p>
          <v-btn bottom v-on:click="choseEmpty()">{{ $t("global.choose") }}</v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="12" lg="4" class="choose-box elevation-5"
          ><h3>{{ $t("delegation.delegationNew.basedOnDelegationOrder") }}</h3>
          <v-icon size="150px" class="font-weight-regular">fa-calendar-check</v-icon>
          <p>
            {{ $t("delegation.delegationNew.basedOnDelegationOrderDescription") }}
          </p>
          <v-btn v-on:click="choseBasedOnOrder()" bottom>{{ $t("global.choose") }}</v-btn>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "DelegationStartView",
  data: () => ({ users: [] }),
  computed: {},
  methods: {
    choseEmpty: function() {
      this.redirectToDelegation();
    },
    choseBasedOnOrder: function() {
      this.$router.push({ path: "/delegation/start-choose-order" });
      //this.redirectToDelegation();
    },
    redirectToDelegation: function() {
      this.$router.push({ path: "/delegation/new" });
    }
  },
  mounted() {
    this.$store.dispatch("Visual/setHalfBackground");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
  },
  created() {
    let userProperty = this.$store.getters["userProperties"];
    if (userProperty.system_settings.delegation_order_type === 3) {
      this.$router.replace({ path: "/delegation/start-choose-order" });
    }
    if (userProperty.system_settings.delegation_order_type === 1) {
      this.$router.replace({ path: "/delegation/new" });
    }
  }
};
</script>

<style scoped></style>
